import React, { Component } from "react";
import styles from "./content.module.scss";
import { Route, Switch } from "react-router";
import RoutesBar from "../sections/sideBars/routesBar";
import CarsBar from "../sections/sideBars/carsBar";
import ControlPoints from "./ControlPointsMap/ControlPoints";
import RouteTripsContent from "./RouteTripsContent/RouteTripsContent";
import { withRoutes } from "../../shared/containers/containerRoutes";
import { withControlPoints } from "../../shared/containers/containerControlPoints";

class RoutesControlPointsContent extends Component {
  render() {
    return (
      <div>
        <Switch>
          <Route
            exact
            path={[
              "/routes/controlPoints",
              "/routes/trips",
              "/routes/:routeId/trips",
              "/routes/:routeId/trips/:id",        
              "/routes/:routeId/controlPoints",
            ]}
          >
            <div className={this.props.isSideBarOpen ? styles.content : styles.content_closedBar}>
              <div className={styles.container_sideBar}>
                <Switch>
                  <Route
                    exact
                    path={["/routes/controlPoints", "/routes/trips", "/routes/:routeId/trips", "/routes/:routeId/controlPoints"]}
                    component={RoutesBar}
                  />
                  <Route exact path={["/routes/:routeId/trips/:id"]} component={CarsBar} />
                </Switch>
              </div>
              <div className={styles.container_sideContent}>
                <Switch>
                  <Route exact path={["/routes/controlPoints", "/routes/:routeId/controlPoints"]} component={ControlPoints} />
                  <Route
                    exact
                    path={["/routes/trips", "/routes/:routeId/trips", "/routes/:routeId/trips/:id"]}
                    component={RouteTripsContent}
                  />
                </Switch>
              </div>
            </div>
          </Route>
        </Switch>
      </div>
    );
  }
}

export default withControlPoints(withRoutes(RoutesControlPointsContent));
